
import IconAction from '@/components/IconAction/IconAction.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    IconAction,
  },
})
export default class PublisherInventorySection extends Vue {
  @Prop() localValue!: any

  @Prop() rowData!: any

  public limit_report_name_displays: number = 3

  public sections: any = [
    {
      title: 'Live',
      key: 'live',
    },
    {
      title: 'FEP',
      key: 'fep',
    },
    {
      title: 'Home Team',
      key: 'home',
    },
  ]

  public limitSelections(arr: Array<any>) {
    if (!arr) return []
    return arr.length > length ? arr.slice(0, this.limit_report_name_displays) : arr
  }

  public getPublisherItem(key: string) {
    if (
      !this.localValue.line_items[this.rowData.index].metadata
      || !this.localValue.line_items[this.rowData.index].metadata?.publishers
    ) {
      return []
    }
    if (this.localValue.line_items[this.rowData.index].metadata?.publishers.hasOwnProperty(key)) {
      return this.localValue.line_items[this.rowData.index].metadata?.publishers[key]
    }
    return []
  }

  public getUsedPercentage(section: string) {
    let using = this.localValue.line_items[this.rowData.index].metadata?.targets[section] || 0

    return parseInt(using)
  }
}
